module.exports = __webpack_public_path__ + "static/media/mulher_r1_c2.7371505b.jpg";